import React from 'react';
import Slider from 'react-slick';
import pic1 from '../Assets/africa.png';
import pic2 from '../Assets/ifra.png';
import pic3 from '../Assets/LOGO AKACH.png';
import pic6 from '../Assets/logo-richbond.png';
import pic4 from '../Assets/sanamot.png';
import pic5 from '../Assets/zpzlco.png';

// Flèche Précédent nettoyée
const CustomPrevArrow = ({ onClick }) => {
	return (
		<button
			type="button"
			aria-label="Image précédente"
			onClick={(e) => {
				e.preventDefault();
				if (onClick) onClick(e);
			}}
			style={{
				position: 'absolute',
				top: '50%',
				left: '0px',
				transform: 'translateY(-50%)',
				zIndex: 1,
				backgroundColor: '#87152B',
				borderRadius: '50%',
				padding: '10px',
				cursor: 'pointer',
				boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
				border: 'none'
			}}
		>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				style={{ height: '20px', width: '20px', color: 'white' }}
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'
				strokeWidth={2}
			>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					d='M15 19l-7-7 7-7'
				/>
			</svg>
		</button>
	);
};

// Flèche Suivant nettoyée
const CustomNextArrow = ({ onClick }) => {
	return (
		<button
			type="button"
			aria-label="Image suivante"
			onClick={(e) => {
				e.preventDefault();
				if (onClick) onClick(e);
			}}
			style={{
				position: 'absolute',
				top: '50%',
				right: '0px',
				transform: 'translateY(-50%)',
				zIndex: 1,
				backgroundColor: '#87152B',
				borderRadius: '50%',
				padding: '10px',
				cursor: 'pointer',
				boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
				border: 'none'
			}}
		>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				style={{ height: '20px', width: '20px', color: 'white' }}
				fill='none'
				viewBox='0 0 24 24'
				stroke='currentColor'
				strokeWidth={2}
			>
				<path
					strokeLinecap='round'
					strokeLinejoin='round'
					d='M9 5l7 7-7 7'
				/>
			</svg>
		</button>
	);
};

const ReferencesCarousel = () => {
	const references = [
		{ id: 1, name: 'Afriquia', logo: pic1 },
		{ id: 2, name: 'Ingelec', logo: pic2 },
		{ id: 3, name: 'AKACH', logo: pic3 },
		{ id: 4, name: 'Sanam', logo: pic4 },
		{ id: 5, name: 'Partenaire Industriel', logo: pic5 },
		{ id: 6, name: 'Richbond', logo: pic6 }
	];

	const settings = {
		dots: false,
		infinite: true,
		autoplay: true,
		speed: 500,
		autoplaySpeed: 2000,
		cssEase: 'linear',
		slidesToShow: 4,
		slidesToScroll: 1,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}
		]
	};

	return (
		/* ID d'ancrage "references" et offset de scroll pour la Navbar fixe */
		<div id='references' className='flex items-center justify-center w-full my-4 scroll-mt-32'>
			<div className='w-full md:w-[80%] h-[200px] flex items-center justify-center bg-white'>
				<div className='w-[90%] bg-white p-4 rounded-xl shadow border border-gray-100'>
					<h2 className='text-lg text-[#87152B] text-left font-semibold border-b-[#87152B] border-b-2 uppercase'>
						NOS RÉFÉRENCES & PARTENAIRES AU MAROC
					</h2>

					<Slider {...settings}>
						{references.map((ref) => (
							<div key={ref.id} className='slide-container p-2'>
								<img
									src={ref.logo}
									alt={`Référence client CFCAE - ${ref.name}`}
									className='slide-image mx-auto max-h-24 object-contain'
								/>
							</div>
						))}
					</Slider>
				</div>
			</div>
		</div>
	);
};

export default ReferencesCarousel;